export const Common = {
  color: {
    primary: "#323232",
    //흰색
    p000: "#ffffff",
    p100: "#f5f5f5",
    p200: "#dbdbdb",
    p300: "#c2c2c2",
    p400: "#a8a8a8",
    p500: "#8f8f8f",
    p600: "#757575",
    p700: "#5c5c5c",
    p800: "#424242",
    p900: "#292929",
    p1000: "#000000",

    // 오렌지
    f900: "#FF4D35",
    // 갈색
    b900: "#4A3838",
    //카카오 배경색
    y900: "#ffcd50",
  },
};
